/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-syncptp-poster',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-syncptp-poster.component.scss']
})
export class NestedSidebarSyncptpPosterComponent implements OnInit {

  constructor() { }

  pdf = {
    pdfTitle: 'Packet Network<br>Synchronization Poster',
    pdfimg: './assets/images/sidebar/D99-00-013P_Packet_Network_Synchroniztion_Reference_Poster.webp',
    url: 'syncptpposter',
    opt: 'BUTTON.DOWNLOADREQ',
    width: '600',
    height: '400'
  };

  ngOnInit(): void {
  }

}
